<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
    <cookie-law buttonText="ACEPTO " theme="dark-lime">
      <div slot="message">
        Esta página web utiliza cookies. Si continúas navegando, consideramos que aceptas su uso.
        Puedes obtener más información
        <router-link to="/politica-de-cookies">aquí</router-link>
. ¡Bienvenid@!
      </div>
    </cookie-law>
  </div>
</template>

<script>
require("waypoints/lib/noframework.waypoints.js");

import header from "@/components/parts/header";
import footer from "@/components/parts/footer";
import CookieLaw from "vue-cookie-law";

export default {
  name: "App",
  components: {
    "app-header": header,
    "app-footer": footer,
    "cookie-law": CookieLaw
  },
  mounted() {
    this.waypoints();
  },
  watch: {
    $route: function() {
      let that = this;
      setTimeout(function() {
        that.waypoints();
      }, 100);
    }
  },
  methods: {
    waypoints: function() {
      
      $(".waypoints-instant").addClass("animated fadeInUp");

      var waypoints = document.getElementsByClassName("waypoints");

      for (var i = 0; i < waypoints.length; i++) {
        new Waypoint({
          element: waypoints[i],
          offset: "100%",
          handler: function() {
            var element = this.key.split("-")[1];
            var effect = this.element.attributes.getNamedItem("data");
            effect != undefined
              ? (effect = effect.value)
              : (effect = "fadeInUp");
            this.element.classList.add("animated", effect);
          }
        });
      }
    }
  }
};
</script>

<style  lang="scss">
@import "./assets/css/style.scss";
@import "./assets/css/slick.css";
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,700");
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.1/animate.min.css);
.Cookie__content {
  width: 100%;
  font-weight: bold;
  a {
    text-decoration: underline;
  }
}
.Cookie--dark-lime .Cookie__button {
  background: #e1ecd0;
  color: #424851!important;
  font-weight: bold;
}
.mvl {
  &.-enlaceWeb {
    margin-top: 25px;
    margin-bottom: 25px;
    a {
      color: #9cb972;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue